import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '/api';

const PROVINCIAS = ["San José","Alajuela","Cartago","Heredia","Guanacaste","Puntarenas","Limón"];

export default function Distribuidores() {
  const [distribuidores, setDistribuidores] = useState([]);
  const [provinciaActiva, setProvinciaActiva] = useState('San José');

  useEffect(() => {
    axios.get(`${API}/distribuidores/`).then(r => setDistribuidores(r.data)).catch(() => {});
  }, []);

  const filtrados = (distribuidores as any[]).filter((d: any) => d.provincia === provinciaActiva);

  return (
    <main className="min-h-screen bg-gray-50">
      <div className="bg-azul py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-white/40 text-xs tracking-widest mb-2">RED DE DISTRIBUCIÓN</div>
          <h1 className="font-condensed text-5xl font-black text-white">Distribuidores</h1>
          <p className="text-white/60 mt-2">Encontrá un distribuidor autorizado en tu provincia</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        {/* Tabs de provincias */}
        <div className="flex gap-2 flex-wrap mb-10">
          {PROVINCIAS.map(p => (
            <button key={p} onClick={() => setProvinciaActiva(p)}
              className={`px-5 py-2 rounded-full text-sm font-bold border transition-all ${
                provinciaActiva === p
                  ? 'bg-azul text-white border-azul shadow-lg'
                  : 'bg-white text-gray-500 border-gray-200 hover:border-azul hover:text-azul'
              }`}>
              {p}
            </button>
          ))}
        </div>

        {/* Distribuidores de la provincia */}
        {filtrados.length > 0 ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtrados.map((d: any) => (
              <div key={d.id} className="bg-white rounded-2xl border border-gray-100 overflow-hidden hover:shadow-lg hover:border-azul/30 transition-all">
                {d.foto_url ? (
                  <img src={d.foto_url} alt={d.nombre} className="w-full h-44 object-cover"/>
                ) : (
                  <div className="bg-gradient-to-br from-azul to-azul-light h-44 flex items-center justify-center">
                    <span className="text-6xl">🏪</span>
                  </div>
                )}
                <div className="p-6">
                  <div className="inline-block bg-rojo text-white text-xs font-black px-3 py-1 rounded mb-3 tracking-wider">{d.provincia}</div>
                  <h3 className="font-condensed text-xl font-black text-azul mb-2">{d.nombre}</h3>
                  {d.descripcion && <p className="text-gray-500 text-sm mb-4 leading-relaxed">{d.descripcion}</p>}
                  <div className="space-y-2">
                    {d.direccion && <div className="flex items-start gap-2 text-sm text-gray-600"><span>📍</span>{d.direccion}</div>}
                    {d.telefono && <div className="flex items-center gap-2 text-sm text-gray-600"><span>📞</span>{d.telefono}</div>}
                    {d.whatsapp && (
                      <a href={`https://wa.me/${d.whatsapp.replace(/\D/g,'')}`} target="_blank" rel="noreferrer"
                        className="flex items-center gap-2 text-sm text-green-600 font-medium hover:underline">
                        <span>💬</span>WhatsApp
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="text-6xl mb-4">📍</div>
            <h3 className="font-condensed text-2xl font-black text-azul mb-2">Próximamente en {provinciaActiva}</h3>
            <p className="text-gray-500 text-sm mb-6">Estamos expandiendo nuestra red de distribuidores.</p>
            <a href="/contacto" className="bg-azul text-white px-8 py-3 rounded-xl font-bold text-sm hover:bg-azul-dark transition-colors inline-block">
              Contactar para más info
            </a>
          </div>
        )}
      </div>
    </main>
  );
}
